module.exports = __webpack_public_path__ + "static/media/apply-img3.13aae91a.png";